import React from 'react';
import classNames from 'classnames';

interface TermProps {
  children: React.ReactNode;
  className?: string;
}

const Term = ({ children, className }: TermProps) => {
  return <dt className={classNames(className, 'col-md-4')}>{children}</dt>;
};

Term.defaultProps = {
  className: null,
};

export default Term;
